export default (player, getState, playerMethods) => {
  if (player && player.config.container) {
    player.config.container.tabIndex = -1;
    let waitForKeyUp = false;
    window.addEventListener('keyup', () => {
      waitForKeyUp = false;
    });
    window.addEventListener(
      'keydown',
      (event) => {
        const playerState = getState();

        const isExitInfo = isExitFromFunc(player, playerState, playerMethods);
        if (isExitInfo.isPrevntDefault) {
          event.preventDefault();
        }
        if (isExitInfo.isExit) {
          return;
        }

        let preventDefault = false;
        switch (event.code) {
          case 'Space':
            if (!waitForKeyUp) {
              const state = player.get('state');

              if (state === 2 || state === 5 || state === 4) {
                player.play();
              } else {
                player.pause();
              }
            }
            preventDefault = true;
            break;

          case 'ArrowUp':
            if (player.get('muted')) {
              player.unMute();
            }
            player.setVolume(player.get('volume') + 5);
            preventDefault = true;
            break;

          case 'ArrowDown':
            const newVolume = player.get('volume') - 5;
            if (newVolume <= 0) {
              player.mute();
            } else if (player.get('muted')) {
              player.unMute();
            }
            player.setVolume(newVolume);
            preventDefault = true;
            break;

          // KEYBOARD SEEK MOVED TO SEEKBAR->SLIDER
          // case 'ArrowRight':
          //   resolveSeek(player, 5);
          //   preventDefault = true;
          //   break;

          // case 'ArrowLeft':
          //   resolveSeek(player, -5);
          //   preventDefault = true;
          //   break;

          default:
        }
        if (preventDefault) {
          event.preventDefault();
        }
        waitForKeyUp = true;
      },
      true
    );
    window.addEventListener('keypress', (event) => {
      const playerState = getState();

      const isExitInfo = isExitFromFunc(player, playerState);
      if (isExitInfo.isPrevntDefault) {
        event.preventDefault();
      }
      if (isExitInfo.isExit) {
        return;
      }

      switch (event.code) {
        case 'KeyF': {
          const playerState = getState();
          if (
            !playerState.messageModeData &&
            !event.ctrlKey &&
            !event.metaKey &&
            !event.altKey &&
            !event.shiftKey
          ) {
            if (playerState.isFullscreen) {
              playerMethods.exitFullscreen();
            } else {
              playerMethods.enterFullscreen();
            }
          }
          break;
        }
      }
    });
  }
};

// KEYBOARD SEEK MOVED TO SEEKBAR->SLIDER
// function resolveSeek(player, increment) {
//   const channel = player.get('epg:currentChannel');
//   const videoInfo = player.get('videoInfo');

//   if (channel) {
//     const channelType = channel.type;
//     const state = player.get('interactiveChannel:channelState');
//     if (channelType !== 'regularChannel') {
//       switch (state) {
//         case 'onAir':
//         case 'timeshift':
//           executeSeek(
//             player.get('interactiveChannel:currentPlayingTime') + increment,
//             player.get('interactiveChannel:currentProgramDuration'),
//             (time) => player.emit(`${channelType}:seek`, time)
//           );

//           break;

//         case 'catchup':
//           executeSeek(player.get('position') + increment, player.get('duration'), player.seekTo);
//           break;
//         default:
//       }
//     }
//   } else if (videoInfo && videoInfo.content_type === 'live_dvr') {
//     executeSeek(
//       player.get('liveDvr:position') + increment,
//       player.get('liveDvr:duration'),
//       (time) => player.emit('liveDvr:seek', time)
//     );
//   } else {
//     executeSeek(player.get('position') + increment, player.get('duration'), player.seekTo);
//   }
// }

// function executeSeek(currentTime, duration, seekFunc) {
//   if (currentTime < 0) {
//     currentTime = 0;
//   }
//   if (typeof seekFunc === 'function' && currentTime <= duration - 5) {
//     seekFunc(currentTime);
//   }
// }

function isInputableElement(element) {
  return (
    element instanceof HTMLInputElement ||
    element instanceof HTMLTextAreaElement
  );
}

function isExitFromFunc(player, playerState, playerMethods) {
  const result = {
    isExit: false,
    isPrevntDefault: false,
  };
  if (isInputableElement(document.activeElement)) {
    result.isExit = true;
  } else if (player.get('interactive:fullscreen')) {
    result.isExit = true;
  } else if (
    playerState.adPlaying &&
    playerState.adType !== 'overlay' &&
    !playerMethods.getHybridLinearAdShowed()
  ) {
    result.isExit = true;
    result.isPrevntDefault = true;
  } else if (playerState.smallMode) {
    result.isExit = true;
  }
  return result;
}
